// extracted by mini-css-extract-plugin
export default {"icon":"Icon_icon__w6Pjo","nextStep":"Icon_nextStep__gEN-n","signUp":"Icon_signUp__5eJ1Z","svg":"Icon_svg__jxucm"};